import { render, staticRenderFns } from "./BrandComponentPCEditDialog.vue?vue&type=template&id=8dbd8544&scoped=true"
import script from "./BrandComponentPCEditDialog.vue?vue&type=script&lang=js"
export * from "./BrandComponentPCEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbd8544",
  null
  
)

export default component.exports